export default __webpack_public_path__ + "static/media/Image (4).4b504111.png";